// Accordion/Collapsible für <li> mit .collapsible-header und .collapsible-body
// a11y: ARIA, Keyboard, Fokus, Toggle

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll("li > .collapsible-header");
  items.forEach((header, idx) => {
    const li = header.parentElement;
    const body = li.querySelector(".collapsible-body");
    if (!body) return;

    // ARIA-IDs
    const headerId = header.id || `collapsible-header-${idx}`;
    const panelId = body.id || `collapsible-body-${idx}`;
    header.id = headerId;
    body.id = panelId;

    // ARIA attributes
    header.setAttribute("role", "button");
    header.setAttribute("aria-controls", panelId);
    header.setAttribute("aria-expanded", "false");
    header.setAttribute("tabindex", "0");
    body.setAttribute("role", "region");
    body.setAttribute("aria-labelledby", headerId);
    body.setAttribute("hidden", "");

    // Toggle Funktion
    function toggleAccordion(open) {
      const expanded =
        open !== undefined
          ? open
          : header.getAttribute("aria-expanded") !== "true";
      header.setAttribute("aria-expanded", expanded ? "true" : "false");
      if (expanded) {
        body.removeAttribute("hidden");
      } else {
        body.setAttribute("hidden", "");
      }
    }

    // Click
    header.addEventListener("click", function () {
      toggleAccordion();
    });
    // Keyboard
    header.addEventListener("keydown", function (e) {
      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        toggleAccordion();
      }
      // Arrow navigation
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        const headers = Array.from(
          document.querySelectorAll("li > .collapsible-header")
        );
        const currentIdx = headers.indexOf(header);
        let nextIdx = e.key === "ArrowDown" ? currentIdx + 1 : currentIdx - 1;
        if (nextIdx < 0) nextIdx = headers.length - 1;
        if (nextIdx >= headers.length) nextIdx = 0;
        headers[nextIdx].focus();
      }
    });
  });
});
